import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, IconButton, TextField, Tooltip, Typography, Chip, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from "@mui/material/styles";
import { handleSearch } from '../../Base/helper/baseFunctions';
import { NoData } from '../../Base/views/NotAuthorized';

export const TeamTimeAppliedFilter = ({
    workLocationValue,
    handleWorkLocationChange,
    businessUnitValue,
    handleBusinessUnitChange,
    empNoValue,
    handleEmpNoChange,
    shiftValue,
    handleShiftChange,
    employmentTypeValue,
    handleEmploymentTypeChange,
    handleClearFilter,
    triggerFilter
}) => {
    let filterStyle = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: "8px",
        paddingRight: "8px",
        lineHeight: 1.57143,
        fontSize: "0.875rem",
        color: " #000000",
        backgroundColor: "#FFC107", // Matching ATS yellow primary box
        borderRight: "1px solid rgba(145, 158, 171, 0.24)",
    };
    let filterStyle1 = {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        margin: "4px",
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid rgba(145, 158, 171, 0.24)",
    };

    return (
        <div
            style={{
                display: "flex",
                flexFlow: "row wrap",
                flexGrow: 1,
                alignItems: "center",
            }}
        >
            {workLocationValue?.length > 0 && (
                <div style={filterStyle1}>
                    <Typography style={filterStyle}>Work Location</Typography>
                    <div style={{ display: "flex", flexFlow: "row wrap", padding: "6px" }}>
                        {workLocationValue?.map((loc, index) => (
                            <Chip
                                key={index}
                                sx={{ margin: "4px" }}
                                label={loc?.work_location_name}
                                size="small"
                                onDelete={(e) => { handleWorkLocationChange(loc, e); triggerFilter && triggerFilter(); }}
                            />
                        ))}
                    </div>
                </div>
            )}
            
            {businessUnitValue?.length > 0 && (
                <div style={filterStyle1}>
                    <Typography style={filterStyle}>Business Unit</Typography>
                    <div style={{ display: "flex", flexFlow: "row wrap", padding: "6px" }}>
                        {businessUnitValue?.map((bu, index) => (
                            <Chip
                                key={index}
                                sx={{ margin: "4px" }}
                                label={bu?.name || bu?.businessunit}
                                size="small"
                                onDelete={(e) => { handleBusinessUnitChange(bu, e); triggerFilter && triggerFilter(); }}
                            />
                        ))}
                    </div>
                </div>
            )}

            {empNoValue?.length > 0 && (
                <div style={filterStyle1}>
                    <Typography style={filterStyle}>Employee No</Typography>
                    <div style={{ display: "flex", flexFlow: "row wrap", padding: "6px" }}>
                        {empNoValue?.map((emp, index) => (
                            <Chip
                                key={index}
                                sx={{ margin: "4px" }}
                                label={emp}
                                size="small"
                                onDelete={(e) => { handleEmpNoChange(emp, e); triggerFilter && triggerFilter(); }}
                            />
                        ))}
                    </div>
                </div>
            )}

            {shiftValue?.length > 0 && (
                <div style={filterStyle1}>
                    <Typography style={filterStyle}>Shift</Typography>
                    <div style={{ display: "flex", flexFlow: "row wrap", padding: "6px" }}>
                        {shiftValue?.map((shift, index) => (
                            <Chip
                                key={index}
                                sx={{ margin: "4px" }}
                                label={shift?.shift_name || shift?.shift_type || shift?.name || `Shift ${shift?.shift_roster_configuration_pk}`}
                                size="small"
                                onDelete={(e) => { handleShiftChange && handleShiftChange(shift, e); triggerFilter && triggerFilter(); }}
                            />
                        ))}
                    </div>
                </div>
            )}

            {employmentTypeValue?.length > 0 && (
                <div style={filterStyle1}>
                    <Typography style={filterStyle}>Employment Type</Typography>
                    <div style={{ display: "flex", flexFlow: "row wrap", padding: "6px" }}>
                        {employmentTypeValue?.map((etype, index) => (
                            <Chip
                                key={index}
                                sx={{ margin: "4px" }}
                                label={etype?.etype_name}
                                size="small"
                                onDelete={(e) => { handleEmploymentTypeChange && handleEmploymentTypeChange(etype, e); triggerFilter && triggerFilter(); }}
                            />
                        ))}
                    </div>
                </div>
            )}

            {(workLocationValue?.length > 0 ||
                businessUnitValue?.length > 0 ||
                empNoValue?.length > 0 ||
                shiftValue?.length > 0 ||
                employmentTypeValue?.length > 0) && (
                    <Button
                        color="error"
                        variant="text"
                        startIcon={<DeleteIcon />}
                        onClick={() => { handleClearFilter(); triggerFilter && triggerFilter(); }}
                    >
                        Delete
                    </Button>
                )}
        </div>
    );
};

export const TeamTimeFilter = ({
    handleClearFilter,
    
    worklocationData,
    workLocationValue,
    handleWorkLocationChange,
    setWorkLocationValue,

    businessUnitData,
    businessUnitValue,
    handleBusinessUnitChange,
    setBusinessUnitValue,

    empNoValue,
    setEmpNoValue,
    handleEmpNoChange,

    shiftData,
    shiftValue,
    handleShiftChange,
    setShiftValue,

    employmentTypeData,
    employmentTypeValue,
    handleEmploymentTypeChange,
    setEmploymentTypeValue
}) => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(false);
    const [filteredWorklocationData, setFilteredWorklocationData] = useState([]);
    const [filteredBusinessUnitData, setFilteredBusinessUnitData] = useState([]);
    const [filteredShiftData, setFilteredShiftData] = useState([]);
    const [filteredEmploymentTypeData, setFilteredEmploymentTypeData] = useState([]);
    const [empNoSearchText, setEmpNoSearchText] = useState("");

    useEffect(() => {
        if (worklocationData) {
            setFilteredWorklocationData(worklocationData);
        }
    }, [worklocationData]);

    useEffect(() => {
        if (businessUnitData) {
            setFilteredBusinessUnitData(businessUnitData);
        }
    }, [businessUnitData]);

    useEffect(() => {
        if (shiftData) {
            setFilteredShiftData(shiftData);
        }
    }, [shiftData]);

    useEffect(() => {
        if (employmentTypeData) {
            setFilteredEmploymentTypeData(employmentTypeData);
        }
    }, [employmentTypeData]);

    const actionSummaryStyle = {
        minHeight: 50,
        maxHeight: 50,
        borderRadius: "10px 10px 0px 0px",
        '&.Mui-expanded': {
            minHeight: 50,
            maxHeight: 50,
            backgroundColor: theme?.palette?.primary?.dark,
            color: "white",
        }
    };

    const accordionDetailsStyle = {
        minHeight: "30vh", maxHeight: "30vh", display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        overflowY: "scroll",
    };

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleWorkLocationSearch = (e) => {
        const filter = handleSearch(e.target.value, worklocationData, "work_location_name");
        setFilteredWorklocationData(filter);
    };

    const handleBusinessUnitSearch = (e) => {
        const filter = handleSearch(e.target.value, businessUnitData, "name");
        setFilteredBusinessUnitData(filter);
    };

    const handleShiftSearch = (e) => {
        const filter = handleSearch(e.target.value, shiftData, "shift_name") || handleSearch(e.target.value, shiftData, "shift_type") || handleSearch(e.target.value, shiftData, "name");
        setFilteredShiftData(filter);
    };

    const handleEmploymentTypeSearch = (e) => {
        const filter = handleSearch(e.target.value, employmentTypeData, "etype_name");
        setFilteredEmploymentTypeData(filter);
    };

    const handleEmpNoAdd = (e) => {
        if (e.key === 'Enter' && empNoSearchText.trim()) {
            const newEmpNos = empNoSearchText.split(',').map(s => s.trim()).filter(s => s);
            const uniqueEmpNos = [...new Set([...empNoValue, ...newEmpNos])];
            setEmpNoValue(uniqueEmpNos);
            setEmpNoSearchText("");
        }
    };

    return (
        <div>
            <Box sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0px 10px 16px",
            }}>
                <Typography variant='subtitle1'>Filters</Typography>
                <Box>
                    <Tooltip title="Clear"><IconButton color='error' variant="outlined" onClick={handleClearFilter}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            </Box>
            <Divider />
            <Box sx={{
                minHeight: "70vh", maxHeight: "70vh", display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                overflowY: "scroll",
            }}>
                <Box sx={{ display: "flex", flexDirection: "column", }}>
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={actionSummaryStyle}
                        >
                            <Box style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <Box>
                                    <Typography sx={{ color: expanded === 'panel1' ? "white" : theme.palette.text.primary }} variant='subtitle1' style={{ marginRight: '30px' }}>Work Location</Typography>
                                </Box>
                                {workLocationValue?.length > 0 && <Box>
                                    <IconButton color='error' variant="outlined" onClick={(e) => { e.stopPropagation(); setWorkLocationValue([]); }}>
                                        <DeleteIcon fontSize='small' />
                                    </IconButton>
                                </Box>}
                            </Box>
                        </AccordionSummary>
                        {worklocationData?.length > 0 ? (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <TextField
                                        variant="standard"
                                        type={"text"}
                                        onChange={(e) => handleWorkLocationSearch(e)}
                                        id="worklocation_search"
                                        size="small"
                                        label="Search Work Location"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                </Box>
                                <FormControl component="fieldset" variant="standard">
                                    <FormGroup>
                                        {filteredWorklocationData?.map((loc, index) => {
                                            const locId = loc?.work_location_id ?? loc?.id ?? loc?.ats_work_location_id;
                                            const isChecked = Boolean(locId !== undefined && locId !== null && workLocationValue?.some(l => (l?.work_location_id ?? l?.id ?? l?.ats_work_location_id) === locId));
                                            return (
                                                <FormControlLabel key={index}
                                                    control={<Checkbox size='small' checked={isChecked} onChange={(e) => handleWorkLocationChange(loc, e)} name={locId?.toString()} />} label={loc?.work_location_name}
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </FormControl>
                            </AccordionDetails>
                        ) : (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <NoData title={"No filter available"} />
                            </AccordionDetails>
                        )}
                    </Accordion>

                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            sx={actionSummaryStyle}
                        >
                            <Box style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <Box>
                                    <Typography sx={{ color: expanded === 'panel2' ? "white" : theme.palette.text.primary }} variant='subtitle1' style={{ marginRight: '30px' }}>Business Unit</Typography>
                                </Box>
                                {businessUnitValue?.length > 0 && <Box>
                                    <IconButton color='error' variant="outlined" onClick={(e) => { e.stopPropagation(); setBusinessUnitValue([]); }}>
                                        <DeleteIcon fontSize='small' />
                                    </IconButton>
                                </Box>}
                            </Box>
                        </AccordionSummary>
                        {businessUnitData?.length > 0 ? (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <TextField
                                        variant="standard"
                                        type={"text"}
                                        onChange={(e) => handleBusinessUnitSearch(e)}
                                        id="businessunit_search"
                                        size="small"
                                        label="Search Business Unit"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                </Box>
                                <FormControl component="fieldset" variant="standard">
                                    <FormGroup>
                                        {filteredBusinessUnitData?.map((bu, index) => {
                                            const buId = bu?.businessunit_id ?? bu?.id ?? bu?.business_unit_id;
                                            const isChecked = Boolean(buId !== undefined && buId !== null && businessUnitValue?.some(b => (b?.businessunit_id ?? b?.id ?? b?.business_unit_id) === buId));
                                            return (
                                                <FormControlLabel key={index}
                                                    control={<Checkbox size='small' checked={isChecked} onChange={(e) => handleBusinessUnitChange(bu, e)} name={buId?.toString()} />} label={bu?.name || bu?.businessunit}
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </FormControl>
                            </AccordionDetails>
                        ) : (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <NoData title={"No filter available"} />
                            </AccordionDetails>
                        )}
                    </Accordion>

                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                            sx={actionSummaryStyle}
                        >
                            <Box style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <Box>
                                    <Typography sx={{ color: expanded === 'panel3' ? "white" : theme.palette.text.primary }} variant='subtitle1' style={{ marginRight: '30px' }}>Employee No</Typography>
                                </Box>
                                {empNoValue?.length > 0 && <Box>
                                    <IconButton color='error' variant="outlined" onClick={(e) => { e.stopPropagation(); setEmpNoValue([]); }}>
                                        <DeleteIcon fontSize='small' />
                                    </IconButton>
                                </Box>}
                            </Box>
                        </AccordionSummary>
                        
                        <AccordionDetails sx={accordionDetailsStyle}>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Typography variant="caption" color="textSecondary" sx={{ mb: 1 }}>
                                    Type multiple IDs separated by comma and press Enter
                                </Typography>
                                <TextField
                                    variant="standard"
                                    type={"text"}
                                    value={empNoSearchText}
                                    onChange={(e) => setEmpNoSearchText(e.target.value)}
                                    onKeyDown={handleEmpNoAdd}
                                    id="empno_search"
                                    size="small"
                                    label="Add Employee No"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                                <div style={{ display: "flex", flexFlow: "row wrap" }}>
                                    {empNoValue?.map((emp, index) => (
                                        <Chip
                                            key={index}
                                            sx={{ margin: "4px" }}
                                            label={emp}
                                            size="small"
                                            onDelete={(e) => { handleEmpNoChange(emp, e); }}
                                        />
                                    ))}
                                </div>
                            </Box>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4bh-content"
                            id="panel4bh-header"
                            sx={actionSummaryStyle}
                        >
                            <Box style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <Box>
                                    <Typography sx={{ color: expanded === 'panel4' ? "white" : theme.palette.text.primary }} variant='subtitle1' style={{ marginRight: '30px' }}>Shift</Typography>
                                </Box>
                                {shiftValue?.length > 0 && <Box>
                                    <IconButton color='error' variant="outlined" onClick={(e) => { e.stopPropagation(); setShiftValue && setShiftValue([]); }}>
                                        <DeleteIcon fontSize='small' />
                                    </IconButton>
                                </Box>}
                            </Box>
                        </AccordionSummary>
                        {shiftData?.length > 0 ? (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <TextField
                                        variant="standard"
                                        type={"text"}
                                        onChange={(e) => handleShiftSearch(e)}
                                        id="shift_search"
                                        size="small"
                                        label="Search Shift"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                </Box>
                                <FormControl component="fieldset" variant="standard">
                                    <FormGroup>
                                        {filteredShiftData?.map((shift, index) => {
                                            const sId = shift?.shift_roster_configuration_id ?? shift?.shift_roster_configuration_pk ?? shift?.shift_id ?? shift?.id ?? shift?.shift_type_id;
                                            const sLabel = shift?.shift_name || shift?.shift_type || shift?.name || `Shift ${sId}`;
                                            const isChecked = Boolean(sId !== undefined && sId !== null && shiftValue?.some(s => (s?.shift_roster_configuration_id ?? s?.shift_roster_configuration_pk ?? s?.shift_id ?? s?.id ?? s?.shift_type_id) === sId));
                                            return (
                                                <FormControlLabel key={index}
                                                    control={<Checkbox size='small' checked={isChecked} onChange={(e) => handleShiftChange(shift, e)} name={sId?.toString()} />}
                                                    label={sLabel}
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </FormControl>
                            </AccordionDetails>
                        ) : (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <NoData title={"No filter available"} />
                            </AccordionDetails>
                        )}
                    </Accordion>

                    {/* Employment Type */}
                    <Accordion expanded={expanded === 'panel_employment_type'} onChange={handleChange('panel_employment_type')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel_employment_typebh-content"
                            id="panel_employment_typebh-header"
                            sx={actionSummaryStyle}
                        >
                            <Box style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <Box>
                                    <Typography sx={{ color: expanded === 'panel_employment_type' ? "white" : theme.palette.text.primary }} variant='subtitle1' style={{ marginRight: '30px' }}>Employment Type</Typography>
                                </Box>
                                {employmentTypeValue?.length > 0 && <Box>
                                    <IconButton color='error' variant="outlined" onClick={(e) => { e.stopPropagation(); setEmploymentTypeValue && setEmploymentTypeValue([]); }}>
                                        <DeleteIcon fontSize='small' />
                                    </IconButton>
                                </Box>}
                            </Box>
                        </AccordionSummary>
                        {employmentTypeData?.length > 0 ? (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <TextField
                                        variant="standard"
                                        type={"text"}
                                        onChange={(e) => handleEmploymentTypeSearch(e)}
                                        id="employment_type_search"
                                        size="small"
                                        label="Search Employment Type"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                </Box>
                                <FormControl component="fieldset" variant="standard">
                                    <FormGroup>
                                        {filteredEmploymentTypeData?.map((etype, index) => {
                                            const eId = etype?.employmenttype_id;
                                            const eLabel = etype?.etype_name;
                                            const isChecked = Boolean(eId && employmentTypeValue?.some(e => e?.employmenttype_id === eId));
                                            return (
                                                <FormControlLabel key={index}
                                                    control={<Checkbox size='small' checked={isChecked} onChange={(e) => handleEmploymentTypeChange(etype, e)} name={eId?.toString()} />}
                                                    label={eLabel}
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </FormControl>
                            </AccordionDetails>
                        ) : (
                            <AccordionDetails sx={accordionDetailsStyle}>
                                <NoData title={"No filter available"} />
                            </AccordionDetails>
                        )}
                    </Accordion>

                </Box>
            </Box>
        </div>
    );
};
